import ApplicationController from './application_controller';

// The payer form's UB-04 fields only apply when the claim format is Institutional (837I).
// They are hidden rather than removed from the DOM: a hidden input still submits its loaded
// value, so flipping the format back and forth never overwrites what is already stored.
//
// Markup (organizations_insurance_companies/_institutional_fields):
//   <div data-controller="claim-format-fields">
//     <%= Impulse select ..., data: { action: 'awc-autocomplete:commit->claim-format-fields#formatChanged' } %>
//     <div data-claim-format-fields-target="institutionalField" hidden>…</div>
//
// The server renders the correct initial state from the payer's stored claim_format, so there is
// no connect() work -- which also avoids reading .value off an Impulse select before the custom
// element has upgraded.
export default class extends ApplicationController {
  static targets = ['institutionalField'];

  static values = { institutional: { type: String, default: 'institutional' } };

  // Impulse selects emit awc-autocomplete:commit, not a native change event; the committed
  // option arrives as event.detail.target (see patient_insurance_form_controller).
  formatChanged(event) {
    const { target } = event.detail;
    this.apply(target.getAttribute('value'));
  }

  /**
   * @private
   */
  apply(format) {
    const institutional = format === this.institutionalValue;

    this.institutionalFieldTargets.forEach((field) => {
      field.hidden = !institutional;
    });
  }
}
